import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    getStatistics: host + 'reporter/getResourceStatics',//资源统计信息
    getDeptStaticsNew: host + 'reporter/getDeptStaticsNew', //部门业务统计
    getReportStaticsNew: host + 'reporter/getReportStaticsNew', //老版记者业务统计弃用
    getStoryTypeCountResult: host + 'storyNew/getStoryTypeCountResult', //稿件统计
    getPersonStaticsNew: host +  'reporter/getPersonStaticsNew', //个人业务统计
    getTopic: host + 'topicSelection/getUserTopicSelectionTotal', //选题业务统计
    getMediaPublishNum: host + 'media/getMediaPublishNum', //编辑业务统计
    getInterviewTotal: host + 'interview/getInterviewTotal', //记者业务统计
    getMediaName: host + 'media/getMediaName', //根据媒体类型获取媒体名称


};

export const getStatistics = (body, callBack) => {  //资源统计信息
    request({url:Apis.getStatistics, body, callBack});
}

export const getDeptStaticsNew = (body, callBack) => { //部门业务统计
    request({url:Apis.getDeptStaticsNew, body, callBack});
}

export const getInterviewTotal = (body, callBack) => { //记者业务统计
    request({url:Apis.getInterviewTotal, body, callBack});
}

export const getStoryTypeCountResult = (body, callBack) => { //稿件统计
    request({url:Apis.getStoryTypeCountResult, body, method:"post", callBack});
}

export const getPersonStaticsNew = (body, callBack) => {  //个人业务统计
    request({url:Apis.getPersonStaticsNew, body, method:"post", callBack});
}

export const getTopic= (body, callBack) => {  //选题统计
    request({url:Apis.getTopic, body, callBack});
}
export const getMediaPublishNum= (body, callBack) => {  //编辑业务统计
    request({url:Apis.getMediaPublishNum, body, callBack});
}
export const getMediaName= (body, callBack) => {  //根据媒体类型活成媒体名称
    request({url:Apis.getMediaName, body, callBack});
}